import React, { useEffect, useState, useCallback, useRef } from 'react';
import SeedImg from './img/Seed.png';
import SeedImg2 from './img/Seed2.png';
import picksound from './music/pick.mp3';

const Seed = ({ isBallBouncing, onSeedCollect, resetSeed, throwSeed }) => {
    const [seeds, setSeeds] = useState([]);
    const papanRef = useRef(null);
    const picksoundRef = useRef(new Audio(picksound)); // Membuat referensi untuk sound effect

    const generateSeeds = useCallback(() => {
        const newSeeds = [];
        const papanWidth = papanRef.current.offsetWidth;
        const papanHeight = papanRef.current.offsetHeight;

        for (let i = 0; i < 6; i++) {
            const x = Math.random() * (papanWidth - 80); // Menghasilkan koordinat x acak dalam rentang lebar papan
            const y = Math.random() * (papanHeight - 80); // Menghasilkan koordinat y acak dalam rentang tinggi papan
            const image = Math.random() > 0.5 ? SeedImg : SeedImg2; // Memilih gambar secara acak antara SeedImg dan SeedImg2
            newSeeds.push({ x, y, collected: false, image });
        }
        setSeeds(newSeeds);
    }, []);

    useEffect(() => {
        if (throwSeed) {
            generateSeeds();
        }
    }, [throwSeed, generateSeeds]);

    useEffect(() => {
        if (resetSeed) {
            setSeeds([]);
        }
    }, [resetSeed]);

    // Fungsi untuk menangani klik pada biji
    const handleSeedClick = useCallback(
        (index) => {
            if (isBallBouncing) {
                setSeeds((prevSeeds) => {
                    const newSeeds = [...prevSeeds];
                    newSeeds[index].collected = true;
                    return newSeeds;
                });

                picksoundRef.current.play(); // Memainkan sound effect
                onSeedCollect(); // Memberitahu komponen induk tentang pengumpulan biji
            }
        },
        [isBallBouncing, onSeedCollect]
    );

    return (
        <div
            className="relative rounded-2xl lg:w-[29rem] lg:h-[28rem] sm:w-52 sm:h-52 md:h-72 md:w-72"
            ref={papanRef}
        >
            {seeds.map((seed, index) => (
                <div
                    key={index}
                    onClick={() => handleSeedClick(index)}
                    className='lg:w-16 lg:h-12 sm:h-6 sm:w-8 md:h-7 md:w-10'
                    style={{
                        position: 'absolute',
                        left: `${seed.x}px`,
                        top: `${seed.y}px`,
                        backgroundImage: `url(${seed.image})`,
                        backgroundSize: 'cover',
                        opacity: seed.collected ? 0 : 1,
                        pointerEvents: seed.collected ? 'none' : 'auto'
                    }}
                ></div>
            ))}
        </div>
    );
};

export default Seed;
